import { prefixObjectValues } from '../utils';

const modal = {
  form: 'container',
  nameSelect: 'name-select',
  addBtn: 'add-btn',
  name: 'name',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  cityInput: 'city',
  stateSelect: 'state',
  countrySelect: 'country',
  postalInput: 'postal',
  submitBtn: 'submit',
  submitCancel: 'cancel',
};

export default prefixObjectValues(modal, 'facility-form');
